export default __webpack_public_path__ + "static/media/header_b.a466795c.png";